import { ConfigProvider, Modal } from "antd";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import RootContext from "./../context/RootContext";
import { useIdleTimer } from "react-idle-timer";

const Root = (props) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const [heading, setHeading] = useState("Dashboard");

  // react-ildle timer fns onIdle onActive & onAction
  const onIdle = () => {
    setIsModalVisible(true);
  };

  const onActive = () => {};

  const onAction = () => {};

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 900_000,
    throttle: 500,
  });

  //  handle Logout
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    const FrontendURL = `${window.location.protocol}//${window.location.hostname}`;
    const REDIRECT_URL =
      process.env.REACT_APP_ENV == "devlopment"
        ? `${FrontendURL}:3013`
        : `${FrontendURL}`;
    window.location.href = `${REDIRECT_URL}/login?clear=true`;
  };

  // console.log(Math.ceil(getRemainingTime()) / 1000);
  //  console.log(state)
  return (
    <div>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#334e9e",
            colorBgHeader: "#334e9e",
            fontFamily: "Nunito",
            fontWeightStrong: true,
          },
        }}
      >
        {" "}
        <RootContext.Provider
          value={{
            setHeading,
            heading,
          }}
        >
          <Navbar heading={heading} />
          <Outlet />
          <Modal
            open={isModalVisible}
            onOk={() => {
              handleLogout();
            }}
            zIndex={1000}
            closable={false}
            cancelButtonProps={{
              style: {
                display: "none",
              },
            }}
          >
            <p>Session Expired! Please re-login.</p>
          </Modal>
        </RootContext.Provider>
      </ConfigProvider>
    </div>
  );
};

export default Root;
